import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    inTotal: 'in total',
    remainingBalance:
      'Once these transfers are made, your remaining balance will be {0}.',
  },
  fr: {
    inTotal: 'au total',
    remainingBalance:
      'Une fois ces virements effectués, votre solde restant sera de {0}.',
  },
} as const);

export default locales;
